import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';
import { useFilterStore } from '@doltech/ui/lib/figma/LandingFilterV2/useStore';
import { PaginationComponent } from '@doltech/ui/lib/figma/Pagination/Pagination';
import { useListingLandingHelper } from '@doltech/ui/lib/shared/hooks/useListingLandingHelper.hook';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';
import { Link } from '@doltech/ui/lib/figma/Link';
import { useRouter } from 'next/router';

const Main = styled.div`
  .desktop-pagination-wrapper {
    display: none;
  }
  .ant-pagination-item a {
    padding: 0;
  }
  ${fromScreen(776)} {
    .desktop-pagination-wrapper {
      display: block;
    }
  }
`;

export interface ListingPaginationProps {
  totalPages?: number;
  totalElements?: number;
  sectionId?: string;

  supportSEO?: boolean;
  shouldKeepOriginalUrl?: boolean;
  currentPageUrl?: string;
}

export const ListingPagination = observer((props: ListingPaginationProps) => {
  const {
    currentPageUrl,
    totalPages,
    totalElements,
    sectionId,
    supportSEO = false,
    shouldKeepOriginalUrl = false,
  } = props;
  const filter = useFilterStore();
  const { scrollToTopOfSection } = useListingLandingHelper();
  const { page, size } = filter;
  const router = useRouter();
  React.useEffect(() => {
    if (supportSEO && Number(router?.query?.page) > 0) {
      filter.setPage(Number(router.query.page));
    }
  }, [filter, router.query, supportSEO]);

  if (totalPages < 1) return null;

  const onPageChange = (p) => {
    filter.update({ page: p });
    scrollToTopOfSection(sectionId);
  };

  return (
    <Main className="listing-pagination">
      <PaginationComponent
        hideOnSinglePage
        totalPage={totalPages}
        numberPerPage={size}
        onChange={onPageChange}
        defaultPageSize={size}
        current={page || 1}
        total={totalElements}
        showSizeChanger={false}
        itemRender={(pageNum, type: 'page' | 'prev' | 'next', originalElement) => {
          if (supportSEO) {
            switch (type) {
              case 'page': {
                return (
                  <Link
                    href={{
                      pathname: shouldKeepOriginalUrl
                        ? currentPageUrl
                        : currentPageUrl.replace('/category', '').replace('/blog', ''),
                      query: { page: pageNum },
                    }}
                  >
                    {originalElement}
                  </Link>
                );
              }
              case 'prev':
              case 'next':
              default:
            }
          }
          return originalElement;
        }}
      />
    </Main>
  );
});
